module.exports = __webpack_public_path__ + "img/img_05.81fa0644.png";